import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ChevronLeft, ChevronRight } from '../../icons/arrows';
import { getTestIds } from '../../utils/TestIds';
import { IconButton } from '../IconButton';
import { Row } from '../Layout/Row';
import { Typography } from '../Typography';
export const GetMonthPagerTID = (parentTestId)=>getTestIds({
        parentTestId
    });
const STEPPER_CHROME = {
    medium: {
        size: 'medium',
        skin: 'standard'
    },
    compact: {
        size: 'smallMedium',
        skin: 'transparent',
        borderSkin: 'subtle'
    }
};
const CHEVRON_SIZE = {
    medium: undefined,
    compact: 20
};
export const MonthPager = (_0)=>{
    let { heading, canShowEarlier, canShowLater, onEarlier, onLater, texts, size = 'medium', className, testId } = _0, biProps = _object_without_properties(_0, [
        "heading",
        "canShowEarlier",
        "canShowLater",
        "onEarlier",
        "onLater",
        "texts",
        "size",
        "className",
        "testId"
    ]);
    const { MonthPagerTestIds } = GetMonthPagerTID(testId);
    const earlierBi = biProps.bi != null ? {
        bi: biProps.bi.earlierButton
    } : {
        noBi: biProps.noBi
    };
    const laterBi = biProps.bi != null ? {
        bi: biProps.bi.laterButton
    } : {
        noBi: biProps.noBi
    };
    return /*#__PURE__*/ _jsxs(Row, {
        gap: 16,
        alignItems: "center",
        justifyContent: "space-between",
        className: className,
        testId: MonthPagerTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsx(IconButton, _object_spread_props(_object_spread(_object_spread_props(_object_spread({
                aspect: "square",
                bordered: true
            }, STEPPER_CHROME[size]), {
                disabled: !canShowEarlier,
                "aria-label": texts.earlierMonth
            }), earlierBi), {
                testId: MonthPagerTestIds.EarlierMonth(),
                onClick: onEarlier,
                children: /*#__PURE__*/ _jsx(ChevronLeft, {
                    size: CHEVRON_SIZE[size]
                })
            })),
            heading != null && /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph1",
                weight: "normal",
                testId: MonthPagerTestIds.Heading(),
                children: heading
            }),
            /*#__PURE__*/ _jsx(IconButton, _object_spread_props(_object_spread(_object_spread_props(_object_spread({
                aspect: "square",
                bordered: true
            }, STEPPER_CHROME[size]), {
                disabled: !canShowLater,
                "aria-label": texts.laterMonth
            }), laterBi), {
                testId: MonthPagerTestIds.LaterMonth(),
                onClick: onLater,
                children: /*#__PURE__*/ _jsx(ChevronRight, {
                    size: CHEVRON_SIZE[size]
                })
            }))
        ]
    });
};
